import get from 'lodash/get';

import { STATUSES } from 'constants/emailStatus';

const getRelevantCompanyRelation = (companyRelations) =>
  companyRelations &&
  (companyRelations.find((relation) => get(relation, 'email.status') === STATUSES.VALID) ||
    companyRelations.find((relation) => get(relation, 'email.value')) ||
    companyRelations?.[0]);

export default getRelevantCompanyRelation;
